import {
  Exercise,
  Level,
  Phase,
  ScheduleEntryColourCode,
  SessionSequenceEntry,
  WorkoutSettings,
} from '../../../../entities';
import { getInstructorVoiceTip } from '../../utils';
import { SequenceContentEntryBuilder } from '../sequenceContentEntryBuilder';
import { EquipmentInstructions } from '../setupinstructions/equipmentinstructions';

export class RestForFirstExercise extends SequenceContentEntryBuilder {
  public build(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAlternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter?: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
    exerciseFormatDescription?: string,
  ): SessionSequenceEntry {
    return {
      durationInMilliseconds: NaN,
      videoFile: exercise.uniqueReferenceNumber,
      exerciseVersion: exercise._rev,
      displayName: exercise.name,
      displayBurnOrBuildIcon: true,
      progressColourCode: ScheduleEntryColourCode.Rest,
      progressText: 'Start in {seconds}',
      showProcessedMetrics: false,
      showCalculatedMetrics: true,
      tips: Exercise.getFormattedTips(exercise),
      audioTipStartDelay: 500,
      audioTipFileName: getInstructorVoiceTip(exercise, workoutSettings),
      zone,
      quarter,
      phase: Phase.Rest,
      homeBenchInstructionImageUrl: EquipmentInstructions.setupBenchInstructionImageUrl(exercise),
      equipmentWeightInfo: exercise.equipmentWeightInfo,
      exerciseFormatDescription,
    };
  }
}
